import { server_ip } from '../config.js';

export async function fetchContentByKey(key){
    try {
        const response= await fetch(`${server_ip}/api/contents/fetch`,{
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                filter:{key,status:'published'},
                options:{limit:1}
            })
        })
        return await response.json();
    } catch (error) {
        return {errno:1,message:'Unexpected error'}
    }
}

export async function updateContentById(token,_id,data){
    try {
        const response= await fetch(`${server_ip}/api/contents/${_id}`,{
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({data})
        })
        return await response.json();
    } catch (error) {
        return {errno:1,message:'Unexpected error'}
    }
}

